// extracted by mini-css-extract-plugin
module.exports = {"ancillary":"AncillaryCard_ancillary__g56Xc","ancillaryLink":"AncillaryCard_ancillaryLink__new9c","content":"AncillaryCard_content__7QoKV","actions":"AncillaryCard_actions__H5Deb"};